import React, {useState} from 'react';
import styled from 'styled-components';
import Button from '../../../../components/Common/BaseComponentWrappers/MotifButton';
import CreateEditMestModalWrapper from '../../EntityCrud/CreateEditMestModalWrapper';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';
import {labels} from '../../../../util/utils';

const CreateEditEntity = (props) => {
	const {isCreate, isEdit, entityId, onClose, onEntityCreated, onEntityModified, className} = props;

	const [showCreateEditEntityModal, setShowCreateEditEntityModal] = useState(false);

	const handleOnClick = () => {
		setShowCreateEditEntityModal(true);
	};

	const showHideCreateEditEntityModal = () => {
		setShowCreateEditEntityModal(!showCreateEditEntityModal);
		/*reload the underlying body*/
		onClose && onClose();
	};

	return (
		<StyledCreateEditEntity className={`StyledCreateEditEntity ${className}`}>
			<Button
				variant="text-alt"
				className="createEditEntity"
				onClick={handleOnClick}
				iconSource={IconoirPlusCircle}
				showLabel
				showIcon
				isEllipsed
				buttonLabel={entityId ? labels.editMultiEntity : labels.createMultiEntity}
				noOfLines={1}
			/>
			{showCreateEditEntityModal && (
				<CreateEditMestModalWrapper
					entityId={entityId}
					isCreate={isCreate}
					isEdit={isEdit}
					showModal={showCreateEditEntityModal}
					setShowModal={showHideCreateEditEntityModal}
					onEntityCreated={onEntityCreated}
					onEntityModified={onEntityModified}
				/>
			)}
		</StyledCreateEditEntity>
	);
};

const StyledCreateEditEntity = styled.section`
	display: flex;
	justify-content: flex-end;
	width: auto;
	max-width: var(--px-200);
	.motif-text-alt-button {
		.motif-icon {
			svg {
				fill: none !important;
			}
		}
		.StyledEllipse {
			max-width: var(--px-170);
		}
	}
`;

export default CreateEditEntity;
